module.exports = __webpack_public_path__ + "static/media/service8.ca998230.svg";